import { IPointsDetail } from '../../interface/student';

const defaultPointsDetail: IPointsDetail = {
    all_reach_rank: 0,
    basic_rank: 0,
    excellent_rank: 0,
    positive_rank: 0,
    special_approve_points: 0,
    special_recognition_rank: 0,
    total_points: 0,
};
export { defaultPointsDetail };
